import React from 'react';
import { IconType } from 'react-icons';

import { EventForRenderFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import deliverables from './deliverables';
import fundingRequests from './fundingRequests';
import ingestion from './ingestion';
import verification from './verification';

const eventConfig: {
  [domainKey: string]: {
    [actionKey: string]: {
      Component: ({
        event,
      }: {
        event: EventForRenderFragmentGQLType;
      }) => React.ReactElement;
      icon: IconType;
      PanelComponent?: ({
        event,
      }: {
        event: EventForRenderFragmentGQLType;
      }) => React.ReactElement;
    };
  };
} = {
  deliverables,
  fundingRequests,
  ingestion,
  verification,
};

export default eventConfig;
